import React, { Component } from 'react';

import { connect } from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { IconButton } from '@material-ui/core';

import Moment from 'moment';

import Clear from '@material-ui/icons/Clear';



class UpdateRecurrenceConfirmationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
   
        };
    };

    getServeTime(diningItem, timeZoneName) {

        if ((!diningItem || diningItem.dateStart || diningItem.dateEnd) && timeZoneName) {

            const dateStartTimeZone = new Date(new Date(diningItem.dateStart).toLocaleString("en-US", { timeZone: timeZoneName }));
            const dateEndTimeZone = new Date(new Date(diningItem.dateEnd).toLocaleString("en-US", { timeZone: timeZoneName }));

            return `${Moment(dateStartTimeZone).format("MMM D, YYYY")}, ${Moment(dateStartTimeZone).format('LT')} - ${Moment(dateEndTimeZone).format('LT')}`;
        }
        else {
            return ``;
        }
    };


    render() {
        return (
            <>
                <Grid>
                    <Paper elevation={3} className="paperModalCategory" square='false' color='secondary'>
                        <Grid id='category_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                            {/* Title and subtitle */}
                            <Grid item container xs={12} alignItems='center' justifyContent='space-between' style={{height:'10%'}}>
                                <Grid item className="TitleDiningsModal">Confirm Menu Item Changes</Grid>

                                <Grid item style={{paddingRight:'20px'}}>
                                    <IconButton item onClick={()=>this.props.close()}>
                                        <Clear style={{fontSize:'40px', color:'#F0EFEF', opacity:'0.56'}} />
                                    </IconButton>
                                </Grid>
                               
                            </Grid>

                            <Grid item container className="dining_recurrence_container" >
                                <Grid item container justify='center' alignItems='center' className="subtitleMenuItemModal">
                                    <Grid item xs={10} md={12} lg={12} id='message_title'>
                                        How do you want your changes to apply to this recurring menu item?
                                    </Grid>
                                </Grid>


                                {/* Dining Info */}
                                    
                                <Grid item container justify='center' alignItems='flex-start' style={{marginTop:'1rem'}}>
                                    {
                                        (this.props.dining) &&
                                            <Grid id={`category_${this.props.dining._id}`} item container className="padding5">
                                                <Grid item direction="row" spacing={0} className="menuItemBackground alingCenter">
                                                    <Grid item xs={12}>
                                                        {/* Image */}
                                                        <Grid item container className="alingCenter">
                                                        {

                                                            (this.props.dining.imageUrl) ?
                                                                <img
                                                                    className="MenuItemImg"
                                                                    src={this.props.dining.imageUrl}
                                                                    alt={this.props.dining.name}
                                                                />
                                                                :
                                                                <Grid item className="altResidentName">{this.props.dining.name}</Grid>
                                                        }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        {/* dining name */}
                                                        <Grid item container className="alingLeftName" style={{padding:'20px'}}>
                                                            {
                                                                (this.props.dining?.name) ?
                                                                    this.props.dining.name
                                                                    :
                                                                    'N/A'
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid item container className="alingLeftServeTime padding5">
                                                            {
                                                                this.getServeTime(this.props.dining, this.props.timeZone)
                                                            }
                                                        </Grid>

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                    }
                                </Grid>
                            </Grid>
                            
                            {/* Buttons */}
                            <Grid item container className="ModalButtonsContainer alingCenter">
                                <Grid item container className="cancel_changes_btn alingCenter" id='cancel_changes_btn' onClick={() => this.props.cancelChanges()}>
                                    Cancel Changes
                                </Grid>
                                    
                                <Grid item container className="apply_this_occurrence_btn alingCenter" id='Apply_this_occurrence_btn' onClick={() => this.props.applyOneOcurrence()}>
                                    Apply to Just This Occurrence
                                </Grid>
                                    
                                <Grid item container className="apply_all_ocurrences_btn alingCenter" onClick={() => this.props.applyAllOcurrences()}>
                                    Apply to This and Future Occurrences
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </>
        )
    }
}


function mapStateToProps(state) {
    return {

    }
};

export default connect(mapStateToProps, {})(UpdateRecurrenceConfirmationModal);

